/**
 * Utilitário para gerenciar o cache da campanha ativa
 * Garante que o progresso seja preservado ao navegar entre páginas
 */

const CACHE_KEY = 'activeCampaign';

export const campaignCache = {
  /**
   * Salva a campanha no cache
   */
  save: (campaign) => {
    if (!campaign) return;
    
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(campaign));
    } catch (error) {
      // Erro ao salvar campanha no cache
    }
  },

  /**
   * Carrega a campanha do cache
   */
  load: () => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const campaign = JSON.parse(cached);
        return campaign;
      }
    } catch (error) {
      campaignCache.clear(); // Limpar cache corrompido
    }
    return null;
  },

  /**
   * Remove a campanha do cache
   */
  clear: () => {
    try {
      localStorage.removeItem(CACHE_KEY);
    } catch (error) {
      // Erro ao limpar cache
    }
  },

  /**
   * Mescla dados da API com dados do cache, preservando o maior progresso
   */
  merge: (apiData, cachedData) => {
    if (!apiData) return cachedData;
    if (!cachedData) return apiData;

    // Se não são a mesma campanha, usar dados da API
    if (apiData.id !== cachedData.id) {
      return apiData;
    }

    // Mesclar dados, preservando o maior progresso
    const merged = {
      ...apiData,
      sentCount: Math.max(
        apiData.sent_count || apiData.sentCount || 0,
        cachedData.sentCount || 0
      ),
      totalContacts: apiData.total_contacts || apiData.totalContacts || cachedData.totalContacts || 0,
      // Preservar outros dados importantes do cache se não estão na API
      interval: apiData.interval || cachedData.interval,
      message: apiData.message || cachedData.message, // Preservar mensagem da campanha
      createdAt: apiData.createdAt || cachedData.createdAt
    };

    return merged;
  },

  /**
   * Atualiza o cache apenas se os novos dados são mais recentes
   */
  updateIfNewer: (newCampaign) => {
    const cached = campaignCache.load();
    
    if (!cached || !newCampaign) {
      campaignCache.save(newCampaign);
      return;
    }

    // Se é a mesma campanha e tem progresso maior ou igual, atualizar
    if (cached.id === newCampaign.id && 
        (newCampaign.sentCount || 0) >= (cached.sentCount || 0)) {
      campaignCache.save(newCampaign);
    }
  }
};

export default campaignCache;